import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useLanguage } from '../contexts/LanguageContext'

const OrderSuccess = () => {
  const { language } = useLanguage()
  const { id } = useParams()
  const [loading, setLoading] = useState(!!id)
  const [error, setError] = useState('')
  const [order, setOrder] = useState(null)

  useEffect(() => {
    let active = true
    const run = async () => {
      if (!id) return
      try {
        setLoading(true)
        setError('')
        const resp = await fetch(`/api/orders/get?id=${encodeURIComponent(id)}`)
        const data = await resp.json().catch(() => ({}))
        if (!resp.ok) throw new Error(data?.error || 'Failed to load order')
        if (active) setOrder(data.order)
      } catch (e) {
        if (active) setError(e?.message || 'Unexpected error')
      } finally {
        if (active) setLoading(false)
      }
    }
    run()
    return () => { active = false }
  }, [id])

  // Hide any spacer divs with inline style height: 10rem on this page
  useEffect(() => {
    const nodes = document.querySelectorAll('div[style*="height: 10rem"]')
    nodes.forEach((el) => { el.style.display = 'none' })
  }, [])

  const translations = {
    title: { ru: 'Заказ оформлен!', en: 'Order Placed!', es: '¡Pedido Realizado!' },
    message: { ru: 'Спасибо за ваш заказ. Мы отправили подтверждение на вашу электронную почту.', en: 'Thank you for your order. We have sent a confirmation to your email.', es: 'Gracias por su pedido. Hemos enviado una confirmación a su correo electrónico.' },
    orderNumber: { ru: 'Номер заказа', en: 'Order Number', es: 'Número de Pedido' },
    backToShop: { ru: 'Вернуться в магазин', en: 'Back to Shop', es: 'Volver a la Tienda' },
    backToHome: { ru: 'На главную', en: 'Back to Home', es: 'Volver al Inicio' }
  }

  const t = translations

  return (
    <div className="min-h-screen bg-gray-50 pt-48 pb-16 flex items-start justify-center">
      <div className="max-w-md w-full bg-white p-8 sm:p-12 text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <i className="ri-check-line text-4xl text-green-600"></i>
        </div>
        
        <h1 className="text-3xl font-light mb-4 playfair">{t.title[language]}</h1>
        
        <p className="text-gray-600 mb-8 montserrat">
          {t.message[language]}
        </p>

        <div className="bg-gray-50 p-4 mb-8">
          <p className="text-sm text-gray-600 mb-2 montserrat">{t.orderNumber[language]}</p>
          <p className="text-2xl font-light playfair">{order?.order_number || '...'}</p>
        </div>

        {loading && (
          <p className="text-sm text-gray-500 montserrat mb-6">...</p>
        )}
        {error && (
          <p className="text-sm text-red-600 montserrat mb-6">{error}</p>
        )}

        <div className="space-y-3">
          <Link
            to="/shop"
            className="block w-full bg-black text-white py-3 hover:bg-gray-800 transition-colors montserrat"
          >
            {t.backToShop[language]}
          </Link>
          <Link
            to="/"
            state={{ fromOrderSuccess: true }}
            className="block w-full border border-black text-black py-3 hover:bg-black hover:text-white transition-colors montserrat"
          >
            {t.backToHome[language]}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default OrderSuccess

